import type { InputEvent } from './target';

export type InputListener = (event: InputEvent) => void;

export interface InputBus {
  subscribe(fn: InputListener): void;
  unsubscribe(fn: InputListener): void;
  destroy(): void;
}

export function createInputBus(rootEl: HTMLElement): InputBus {
  const subscribers = new Set<InputListener>();

  function publish(event: InputEvent): void {
    for (const fn of subscribers) {
      fn(event);
    }
  }

  function onClick(e: MouseEvent): void {
    const rect = rootEl.getBoundingClientRect();
    publish({
      type: 'click',
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  }

  function onKeyDown(e: KeyboardEvent): void {
    publish({ type: 'key', key: e.key.toLowerCase() });
  }

  rootEl.addEventListener('click', onClick);
  window.addEventListener('keydown', onKeyDown);

  function subscribe(fn: InputListener): void {
    subscribers.add(fn);
  }

  function unsubscribe(fn: InputListener): void {
    subscribers.delete(fn);
  }

  function destroy(): void {
    rootEl.removeEventListener('click', onClick);
    window.removeEventListener('keydown', onKeyDown);
    subscribers.clear();
  }

  return { subscribe, unsubscribe, destroy };
}
